// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".floatLayer{position:fixed;left:0;top:0;z-index:100;width:500px;height:300px;overflow:auto;background:#378cc5;padding:20px;border:1px solid #efefef}.close-btn{display:block;position:absolute;right:0;top:0;width:40px;height:40px;line-height:40px;text-align:center;overflow:hidden;font-size:30px;color:#333;z-index:110}.floatLayer img{position:relative;z-index:101}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
